var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-nav"},[_c('ul',_vm._l((_vm.navs),function(item,index){return _c('li',{key:index,staticClass:"header-list-item",class:item.link == _vm.currentNav ? 'active' : '',on:{"click":function($event){return _vm.changeNav(item.link)}}},[(item.link != '11huodong')?_c('router-link',{attrs:{"to":item.link}},[_c('img',{class:item.link == 'materialDownload' ||
            item.link == 'pay' ||
            item.link == '11huodong' ||
            item.link == 'materialCenter'
              ? 'iconfontleft'
              : 'iconfontNone',attrs:{"src":item.icon}}),_vm._v("\n        "+_vm._s(item.name)+"\n      ")]):_c('router-link',{attrs:{"to":item.link,"target":"_blank"}},[_c('img',{class:item.link == 'materialDownload' ||
            item.link == 'pay' ||
            item.link == '11huodong' ||
            item.link == 'materialCenter' ||
            item.link == 'activity'
              ? 'iconfontleft'
              : 'iconfontNone',attrs:{"src":item.icon}}),_vm._v("\n        "+_vm._s(item.name)+"\n        "),(item.link == '11huodong')?_c('img',{staticClass:"iconfont",attrs:{"src":_vm.newhot,"alt":"","width":"30"}}):_vm._e()])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }